import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone'

// API
import * as API from '../../../../utils/api';

// Components
import AppCanvasLoader from '../../../../components/Global/AppCanvasLoader';


class ParticipationPhotoUploader extends Component {
  static propTypes = {
    participationID: PropTypes.number.isRequired,
    updateParticipation: PropTypes.func.isRequired,

    // from redux
    user: PropTypes.object
  }

  state = {
    uploading: false
  }

  onDropAccepted = (acceptedFiles) => {
    this.setState({uploading: true}, () => this.upload(acceptedFiles[0]))
  }

  upload = (file) => {
    const { user, participationID, updateParticipation } = this.props

    API.uploadPhoto(user, participationID, file)
    .then(() => {
      updateParticipation()
      this.setState({uploading: false})
    })
  }

  onDropRejected = (rejectedFiles) => {
    this.props.setFlashMessage('error', 'Error: Image file size exceeded 500 kb limit. Please try uploading an image less than 500 kb.', true)
  }

  render() {
    const { uploading } = this.state

    return (
      <Dropzone
        className="content participation-photo-uploader"
        acceptClassName="accept-drop"
        rejectClassName="reject-drop"
        onDropAccepted={this.onDropAccepted}
        onDropRejected={this.onDropRejected}
        accept="image/*"
        multiple={false}
        disabled={uploading}
        maxSize={500000}
      >
        { uploading ? <AppCanvasLoader /> : <span>+</span> }
      </Dropzone>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(ParticipationPhotoUploader)



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/PhotoVideo/ParticipationPhotoUploader.js